var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city-tags"},_vm._l((_vm.cities),function(item){return _c('span',{key:item[_vm.fields.id],staticClass:"tag-item no-select-text",class:_vm.getTagClass(item[_vm.fields.id]),on:{"click":function($event){return _vm.changeCity(item)}}},[_vm._v(_vm._s(item[_vm.fields.name]))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }